<div class="flex h-auto w-full flex-col items-center justify-center gap-4 py-24">
  <h1
    class="mb-6 bg-gradient-to-b from-gray-800 to-transparent bg-clip-text text-7xl font-extrabold text-transparent dark:from-white sm:text-9xl">
    404
  </h1>
  <h3 class="my-2 text-3xl font-semibold">Oops! Page not found</h3>
  <p class="max-w-[430px] text-center">We're sorry, but the page you're trying to access does not exist or has been removed.</p>
  <div class="mt-8 flex justify-center items-center gap-8">
    <button hlmBtn (click)="goBack()" size="lg">Go back</button>
    <button hlmBtn variant="link" (click)="goHome()" size="md">Return home</button>
  </div>
</div>
